import CommonService from '../../../../../services/commonService';
import KuposInput from '../../../../common/KuposInput';
import KuposSelectBox from '../../../../common/KuposSelectBox';
import React from 'react';

function PaymentDetailsBookingInput(props) {
  const nameChanged = (text, seat) => {
    props.onNameChange(text, seat);
  };
  const surnameChanged = (text, seat) => {
    props.onSurnameChange(text, seat);
  };
  const inputBlur = (text, seat, inp) => {
    props.onInputBlur(text, seat, inp);
  };
  const countryChanged = (val, seat) => {
    props.onCountryChange(val, seat);
  };
  const idCardChanged = (label, seat) => {
    props.onIdCardChange(label, seat);
  };
  const idCardNumberChanged = (text, seat) => {
    props.onIdCardNumberChange(text, seat);
  };

  const seatInputs = (seat, i) => {
    let passengerDetails = CommonService.copyObject(props.passengerDetails);
    let passenger =
      passengerDetails && passengerDetails.length
        ? passengerDetails.find(it => seat.number == it.seatNumber)
        : null;
    return (
      <tr key={i} className="passenger-input">
        <td className="nationality-input">
          <KuposSelectBox
            options={props.countries}
            selectedOption={passenger ? passenger.nationality : {}}
            onChange={val => countryChanged(val, seat)}
            height={50}
          />
        </td>
        <td className="rut-input">
          <KuposInput
            className="kupos-border"
            type="text"
            placeholder="N°de documento"
            value={passenger ? passenger.idCardNumber : ''}
            onChange={text => idCardNumberChanged(text, seat)}
            onBlur={text => inputBlur(text, seat, 'card_number')}
            error={props.cardNumberError && props.cardNumberError[seat.number] ? true : false}
            errorMessage={
              props.cardNumberError && props.cardNumberError[seat.number]
                ? props.cardNumberError[seat.number].message
                : ''
            }
          />
        </td>
        <td className="name-input">
          <KuposInput
            className="kupos-border"
            type="text"
            placeholder="Nombre y apellido"
            value={passenger ? passenger.name : ''}
            onChange={text => nameChanged(text, seat)}
            onBlur={text => inputBlur(text, seat, 'name')}
            error={props.nameError && props.nameError[seat.number] ? true : false}
            errorMessage={
              props.nameError && props.nameError[seat.number]
                ? props.nameError[seat.number].message
                : ''
            }
          />
        </td>
        <td className="name-input">
          <KuposInput
            className="kupos-border"
            type="text"
            placeholder="Nombre y apellido"
            value={passenger ? passenger.surname : ''}
            onChange={text => surnameChanged(text, seat)}
            onBlur={text => inputBlur(text, seat, 'surname')}
            error={props.surnameError && props.surnameError[seat.number] ? true : false}
            errorMessage={
              props.surnameError && props.surnameError[seat.number]
                ? props.surnameError[seat.number].message
                : ''
            }
          />
        </td>
      </tr>
    );
  };

  return (
    <table>
      <tbody>
        <tr className="passenger-input-heading bold">
          <th className="nationality-input">Nationality</th>
          <th className="rut-input">RUT / Passport / DNI</th>
          <th className="name-input">Name</th>
          <th className="surname-input">Surname</th>
        </tr>
        {props.selectedSeatsToBook.map((seat, i) => seatInputs(seat, i))}
      </tbody>
    </table>
  );
}

export default PaymentDetailsBookingInput;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/PaymentDetailsPage/components/PaymentDetailsBookingInput.js